<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')" title="数据源" name="1">
        <div>
          <div class="data-source-type">
            <cx-slider :value.sync="dataType" :options="dataOptions" :height="32" />
          </div>
          <div v-if="dataType === '1'" class="dataSource-item mt12" @click="goToChooseData">
            <span>进入数据管理后台 </span>
          </div>
          <data-center-choose v-show="dataType === '2'" :checkStatus="checkStatus" :myId="ids" :options="options"
            class="mt12" @onDataCenterChange="onDataCenterChange" />
        </div>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')" title="绑定数据" name="2">
        <div class="content">
          <div v-if="dataType !== '3'"
            :class="currentFiledMappingChecked && currentFieldMappingFieldFlag ? 'mapping_content checked' : 'mapping_content'">
            <div class="verticallyBetweenCenter">
              <div class="content-title">
                文本
              </div>
              <el-checkbox v-model="options.isHyperlink">超链接</el-checkbox>
            </div>
            <div class="select_content mt8">
              <el-select style="width: 100%" @change="setCurrentData()" v-model="currentFieldMappingFieldFlag" placeholder="请选择" clearable>
                <el-option v-for="(item, index) in currentFieldMappingList" :key="index" :label="item.label"
                  :value="item.value">
                  <span style="font-size: 13px">{{ item.label }}</span>
                </el-option>
              </el-select>
            </div>
            <div class="verticallyCenter mapping_date_content mt8">
              <label class="date-label">显示为:</label>
              <el-dropdown trigger="click" @command="onChangeCurrentMappingType">
                <span class="el-dropdown-link">
                  {{ currentFieldMappingDataTypeName }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="custom-dropdown">
                  <el-dropdown-item v-for="item in dataTypeList" :key="item.value" :command="item.value">
                    <div :class="currentFieldMappingDataType === item.value ? 'dropdown-item active' : 'dropdown-item'">
                      {{ item.label }}
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="select_content mt8" v-if="options.isHyperlink">
              <el-select style="width: 100%" @change="setCurrentData()" v-model="currentFiledMapping.linkUrl" placeholder="请选择" clearable>
                <el-option v-for="(item, index) in currentFieldMappingList" :key="index" :label="item.label"
                  :value="item.value">
                  <span style="font-size: 13px">{{ item.label }}</span>
                </el-option>
              </el-select>
            </div>
            <div class="verticallyCenter mt4" v-if="options.isHyperlink">
              <el-checkbox v-model="options.openBlankPage">新页面打开</el-checkbox>
            </div>
          </div>
          <!-- <colsFieldMappingSetting :ids="ids" :options="options" v-if="showColsFieldMapping && dataType === '3'"></colsFieldMappingSetting> -->
          <div v-if="showColsFieldMapping && dataType === '3'" class="mapping_content checked">
            <div class="verticallyBetweenCenter">
              <div class="content-title">
                文本
              </div>
              <el-checkbox v-model="options.isHyperlink">超链接</el-checkbox>
            </div>
            <div class="select_content mt8">
              <p class="select-name">名称</p>
            </div>
            <div class="verticallyCenter mapping_date_content mt8">
              <label class="date-label">显示为:</label>
              <el-dropdown trigger="click" @command="onChangeMappingType">
                <span class="el-dropdown-link">
                  {{ fieldMappingDataTypeName }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="custom-dropdown">
                  <el-dropdown-item v-for="item in dataTypeList" :key="item.value" :command="item.value">
                    <div :class="fieldMappingDataType === item.value ? 'dropdown-item active' : 'dropdown-item'">
                      {{ item.label }}
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="select_content mt8">
              <p class="select-name" v-if="options.isHyperlink">链接</p>
            </div>
            <div class="verticallyCenter mt4" v-if="options.isHyperlink">
              <el-checkbox v-model="options.openBlankPage">新页面打开</el-checkbox>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')" title="高级设置" name="3" v-if="options.appId && dataType !== '3'">
        <auto-update-timer :isLocal="dataType ==='1'" :options="options" unit="分" />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"
import colsFieldMappingSetting from "publicSetting/colsFieldMappingSetting.vue"
import { getValueByType, isExist, getAllColsUidInLayoutComponent, handleFindLayoutComponentOptions } from "utils"
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
export default {
  name: "tabs-options-data",
  props: { options: Object },
  components: {
    dataCenterChoose,
    colsFieldMappingSetting,
    autoUpdateTimer
  },
  data() {
    return {
      activeNames: ["1", "2", "3"],
      collapseActiveNames: ["1", "2", "3"],
      fetchEnd: false,
      currentFieldMappingList: [],
      dataTypeList: [
        {
          label: "字段名称+字段内容",
          value: "dataKey"
        },
        {
          label: "字段内容",
          value: "dataValue"
        },
        {
          label: "字段名称",
          value: "dataName"
        }
      ],
      datas: null,
      fieldMappingList: [],
    }
  },
  created() {
  },
  mounted() {
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  beforeDestroy() {
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  },
  watch: {
    // currentFiledMapping: {
    //   deep: true,
    //   handler(n, o) {
    //     if (this.options?.appId && n && n.isChecked && this.dataType !== '3') {
    //       this.setCurrentData(n)
    //     }
    //   }
    // },
    filedMapping: {
      deep: true,
      handler(n, o) {
        if (n && this.dataType === '3') {
          this.getSearchInfo()
        }
      }
    },
    dataType(n, o) {
      if (n !== o) {
        if (n === "3") {
          this.getSearchInfo()
        } else {
          this.getBaseModuleDataLoop()
        }
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    showColsFieldMapping() {
      return this.ids?.uid || isExist(this.ids?.elementInSwiperId)
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false, null)
      }
    },
    layoutOptions() {
      let rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids, "rect")?.options

      if (rectAttr && isExist(this.ids.elementInAutoLayoutId) && (isExist(this.ids.elementInLayoutId) || isExist(this.ids.elementInSwiperId)) && rectAttr.innerElement === "cxAutoLayout") {
        rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], { ...this.ids, elementInLayoutId: undefined })
      }
      if (rectAttr && rectAttr.innerElement !== "emptyLayoutComponent" && rectAttr.innerElement !== "layoutComponent" && rectAttr.innerElement !== "swiperComponent") return {}
      return rectAttr
    },
    dataType: {
      get() {
        return this.options.dataType || "1"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dataType", false)
      }
    },
    dataOptions() {
      const options = [{ value: "1", title: "本地数据" }, { value: "2", title: "数据中心" }]
      if (this.searchComponentPlugin) {
        options.push({ value: "3", title: "快捷入口" })
      }
      return options
    },
    checkStatus() {
      return this.options.appId
    },
    restDataUrl: {
      get() {
        return this.options && this.options.restDataUrl !== "" ? this.options.restDataUrl : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false)
      }
    },
    currentFiledMapping: {
      get() {
        return this.options.currentFiledMapping
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping", false)
      }
    },
    currentFiledMappingChecked: {
      get() {
        return this.options.currentFiledMapping?.isChecked || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping.isChecked", false)
      }
    },
    currentFieldMappingFieldFlag: {
      get() {
        return this.options.currentFiledMapping?.fieldFlag
      },
      set(newVal) {
        if (!this.currentFiledMapping) {
          this.currentFiledMapping = {}
        }
        if (!this.currentFiledMappingChecked) {
          this.$changeOptionsEV(newVal, "currentFiledMapping.fieldFlag", false)
          this.$changeOptionsEV(true, "currentFiledMapping.isChecked", false, false, false, true)
        } else {
          this.$changeOptionsEV(newVal, "currentFiledMapping.fieldFlag", false)
        }
      }
    },
    currentFieldMappingDataType: {
      get() {
        return this.currentFiledMapping?.dataType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping.dataType", false, null, {
          ...this.ids
        })
      }
    },
    currentFieldMappingDataTypeName() {
      const item = this.dataTypeList.find(data => data.value === this.currentFieldMappingDataType)
      return item?.label || ""
    },
    tabsList: {
      get() {
        return this.options.tabsList
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tabsList", false)
      }
    },
    searchComponentPlugin() {
      return this.layoutOptions?.pluginName?.includes("searchComponentPlugin")
    },
    filedMapping: {
      get() {
        return this.options?.filedMapping || {}
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filedMapping", false)
      }
    },
    fieldMappingDataType: {
      get() {
        return this.filedMapping?.dataType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filedMapping.dataType", false, null, {
          ...this.ids
        })
      }
    },
    fieldMappingDataTypeName() {
      const item = this.dataTypeList.find(data => data.value === this.fieldMappingDataType)
      return item?.label || ""
    },
  },
  methods: {
    goToChooseData() {
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId } = this.$store.state.states.getDataPageIds
      let { moduleId, appId } = this.options
      if (moduleId === undefined) moduleId = this.options?.moduleId
      if (appId === undefined) appId = this.options?.appId
      if (!appId) {
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时")
          .then(res => {
            this.fetchEnd = false
            if (!!res.appId) {
               // 模板问题，第一次需要手动将数据源切换为本地数据
               this.$API.setLocalData({ appId: res.appId, type: "general" }).then(() => {
                window.open(`/engine2/data/api-v2/admin/general/${res.appId}?w=${websiteId}&p=${pageId}&hideDataContent=true`)
              })
            }
          })
          .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if (!!appId) window.open(`/engine2/data/api-v2/admin/general/${appId}?w=${websiteId}&p=${pageId}&hideDataContent=true`)
      // 数据自动渲染
      this.appId = appId
      // window.addEventListener("storage", this.listenData)
    },
    async getBaseModuleDataLoop() {
      if (!this.checkStatus) {
        this.datas = []
        return
      }
      this.noCacheComponent = true
      this.updateNormalRect
        .call(this, datas => {
          if (datas) {
            this.currentFieldMappingList = []
            Object.keys(datas[0]).forEach((key, index) => {
              if (key === "content") return
              if (key && datas[0][key]?.value) {
                const temp = {
                  value: key,
                  label: datas[0][key].key,
                  content: datas[0][key].value
                }
                this.currentFieldMappingList.push(temp)
              }
            })
            this.datas = datas
            this.setCurrentData()
          }
        })
        .then(restDataUrl => {
          this.restDataUrl = restDataUrl
        })
    },
    // 重新组装字段映射的数据结构
    setCurrentData() {
      if (this.datas === null) return
      let tabsList = []
      const fieldFlag = this.currentFiledMapping?.fieldFlag || "0"
      const linkUrl = this.currentFiledMapping?.linkUrl
      if (this.datas.length) {
        this.datas.forEach(item => {
          Object.keys(item).forEach((key, index) => {
            if (key === fieldFlag) {
              let value = ""
              switch (this.currentFiledMapping?.dataType) {
                case "dataKey":
                  value = item[key].key + "：" + item[key].value
                  break
                case "dataName":
                  value = item[key].key
                  break
                default:
                  value = item[key].value
                  break
              }
              tabsList.push({
                content: value,
                name: value,
                link: linkUrl ? item[linkUrl]?.value : ""
              })
            }
          })
        })
      }
      this.tabsList = tabsList
    },
    onDataCenterChange() {
      if (this.dataType === "3") {
        this.getSearchInfo()
      } else {
        this.getBaseModuleDataLoop()
      }
    },
    updateToolbarData() {
      if (this.dataType === "3") {
        this.getSearchInfo()
      } else {
        this.getBaseModuleDataLoop()
      }
    },
    getValueByTypeHandle(type) {
      return getValueByType(type)
    },
    onChangeCurrentMappingType(value) {
      this.currentFieldMappingDataType = value
      this.setCurrentData()
    },
    onChangeMappingType(value) {
      this.fieldMappingDataType = value
    },
    getSearchInfo() {
      const { appId, searchFastLinkData } = this.layoutOptions
      if (this.searchComponentPlugin && appId) {
        this.datas = searchFastLinkData
        this.setFaskLinkData(this.filedMapping)
      } else {
        this.datas = []
      }
    },
    // 重新组装搜索快捷入口的数据结构
    setFaskLinkData(filedMapping) {
      let tabsList = []
      if (this.datas && this.datas.length) {
        this.datas.forEach(item => {
          let value = item.name
          switch (filedMapping.dataType) {
            case "dataKey":
              value = "名称：" + item.name
              break
            case "dataName":
              value = "名称"
              break
            default:
              value = item.name
              break
          }
          const temp = {
            content: item.id,
            name: value,
            link: item.link,
            iconSrc: item.imgUrl,
            iconType: "img"
          }
          tabsList.push(temp)
        })
      }
      this.tabsList = tabsList
    },
    // 获取当前快照
    getQuickShot() {
      const { container_id, rect_id } = this.ids
      const page = this.$store.state[this.request_prefix].page
      const rect = page.children[0].children.find(rect => rect.rect_id === rect_id)
      const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
      const pageLayout = pageLayoutList[this.pageLayoutIndex]
      const data = {
        rect,
        pageLayout
      }
      return deepCloneAndFreeze(data)
    },
    // 记录状态
    addHistory() {
      const newData = this.getQuickShot()
      const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
      this.$addHistory({
        type: "update",
        stateType: "updateTabRect",
        payload: {
          container_id: this.ids.container_id,
          pageLayoutId: pageLayoutList[this.pageLayoutIndex].id,
          rect_id: this.ids.rect_id
        },
        before: this.before,
        data: newData
      })
      this.before = null
    }
  }
}
</script>
<style lang="scss">
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);

  &:hover {
    cursor: pointer;
  }
}

.mapping_content {
  padding: 8px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background-color: rgba(247, 248, 250, 1);

  &.checked,
  &:hover {
    border: 1px solid rgba(36, 0, 255, 0.16);
    background-color: rgba(36, 0, 255, 0.04);
  }

  .content-title {
    height: 18px;
    line-height: 18px;
    font-size: 13px;
  }

  .select_content {
    ::v-deep .el-input__inner {
      font-size: 13px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 0px 1px rgba(233, 233, 233, 1) inset;
    }

    .select-name {
      font-size: 13px;
      background-color: var(--inputBackGround);
      border-radius: 4px;
      height: 32px;
      line-height: 22px;
      padding: 5px 0 5px 12px;
    }
  }

  &.checked {
    .select_content {
      .el-input__inner {
        font-size: 13px;
        background-color: rgba(36, 0, 255, 0.1);
        color: rgba(36, 0, 255, 1);
        box-shadow: 0px 0px 0px 1px rgba(36, 0, 255, 0.16) inset;

        &:hover {
          background-color: rgba(36, 0, 255, 0.2);
        }
      }

      .el-select__caret {
        color: rgba(36, 0, 255, 1);
      }

      .is-focus .el-input__inner {
        background-color: rgba(36, 0, 255, 0.2);
      }

      .select-name {
        background-color: rgba(36, 0, 255, 0.1);
        color: rgba(36, 0, 255, 1);
        box-shadow: 0px 0px 0px 1px rgba(36, 0, 255, 0.16) inset;
      }
    }
  }

  .mapping_date_content {
    height: 20px;

    .date-label {
      font-size: 13px;
      color: var(--thirdTextColor);
      margin-right: 4px;
    }

    ::v-deep .el-dropdown {
      font-size: 13px;
    }
  }

  .el-checkbox {
    margin-right: 4px;
  }

  .vedio-style {
    font-size: 13px;
  }
}

.custom-dropdown {
  .dropdown-title-show {
    padding: 7px 12px;
    border-bottom: 1px solid rgba(233, 233, 233, 1);

    ::v-deep .el-checkbox__label {
      font-size: 13px;
    }
  }

  ::v-deep .el-dropdown-menu__item {
    height: 34px;
    line-height: 34px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.8);

    .active {
      color: rgba(43, 103, 255, 1);
    }
  }
}

.verticallyBetweenCenter {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
